var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-xs-center mt-5" },
    [
      _c("v-icon", {
        attrs: { size: _vm.iconSize },
        domProps: { innerHTML: _vm._s(_vm.icon) },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "subheading",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }